import { fetchApi } from '@/config/axiosSetting';
import { PostAdjusterOpinionQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/postAdjusterOpinion/postAdjusterOpinionQuery.type';

export const postAdjusterOpinionFunction = (
  params: PostAdjusterOpinionQueryParamsType,
) => {
  return fetchApi.patch(`${params.id}/report/adjuster_opinion/`, params.data);
};
